function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.76 0a.51.51 0 00-.55.437V.44l-1 9a.5.5 0 00.437.55h.056a.5.5 0 00.496-.438V9.55l1-9a.499.499 0 00-.437-.549H3.76zm-2 0a.51.51 0 00-.55.437V.44l-1 9a.5.5 0 00.438.56h.056a.5.5 0 00.496-.438V9.56l1-9A.5.5 0 001.762 0H1.76zM15 6a8.953 8.953 0 00-4.119 1.024L10.93 7 10.2.44a.502.502 0 00-1-.092V.35L7.7 5.19 6.18.35a.503.503 0 10-1 .092V.44l-1 9a.503.503 0 001 .112V9.55l.74-6.64L7.23 7a.5.5 0 001 0l1.29-4.1.48 4.63C7.585 9.169 6.02 11.902 6.02 15c0 4.971 4.029 9 9 9s9-4.029 9-9a9 9 0 00-9-9h-.021H15zm.13 15.5a.9.9 0 11.9-.9.9.9 0 01-.9.9zm.63-5.5v1a.631.631 0 01-1.25.003V15.4a.63.63 0 01.63-.62 2.38 2.38 0 10-2.38-2.38.631.631 0 01-1.25.003V12.4a3.63 3.63 0 114.272 3.596l-.022.003z"
});

function SvgMdUnknown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "mdUnknown.c6b0b.svg";
export { SvgMdUnknown as ReactComponent };